import { useCallback, useMemo } from 'react';

import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

import { AllLeaguesItem, buildLeagueSections } from '@/components/league-navigator/utils/all-leagues-utils';
import { useGQLRequestPolicy } from '@/feature/guest-user/hooks/use-gql-request-policy';
import { useGetOrderedLeaguesByEvents } from '@/hooks/use-fantasy-league-configs';
import { RootStackParamList } from '@/navigation/types';
import { League } from '@/types/api.generated';

import { toLeagueNavigatorItem } from '../utils/league-item-utils';

export const usePickemAllLeagues = () => {
    const navigation = useNavigation<NativeStackNavigationProp<RootStackParamList>>();
    const requestPolicy = useGQLRequestPolicy('cache-and-network');
    const { fetching, isSorting, sortedLeagues } = useGetOrderedLeaguesByEvents(false, requestPolicy);

    const sections = useMemo(() => {
        const items = sortedLeagues.map(toLeagueNavigatorItem);
        const leagueIds = sortedLeagues.map(({ league }) => league.league);
        return buildLeagueSections(items, leagueIds);
    }, [sortedLeagues]);

    const onSelectLeague = useCallback(
        (league: AllLeaguesItem) => {
            navigation.popTo('PickemHome', {
                screen: 'Lobby',
                params: { screen: 'LobbyScreen', params: { league: league.id as League } },
            });
        },
        [navigation]
    );

    return { sections, isLoading: fetching || isSorting, onSelectLeague };
};
